import { UPDATE_BACKGROUND_PATTERN } from '../actions';

export const backgroundPattern = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_BACKGROUND_PATTERN: {
      return action.backgroundPattern;
    }
    default:
      return state;
  }
};
